import React from 'react'
import { dataKuliner } from '../../constants';

function Kuliner() {
  return (
    <section id='kuliner' className='background-gradient'>
      <div className="container text-center">
        <div className='mb-5'>
          <h2 className='mb-3'>Kuliner khas di Kota Palu</h2>
          <p className='desc'>Kurang pas rasanya jika anda berkunjung ke Kota Palu namun belum mencicipi makanan khas Kota Palu</p>
        </div>
        <div className='d-flex flex-wrap justify-content-center align-items-center' style={{rowGap: '20px', columnGap: "20px"}}>
          {
            dataKuliner.map(kuliner => {
              return(
                <div 
                  className='d-flex flex-column justify-content-center wisata' 
                  key={kuliner.id}
                  data-aos="zoom-out" 
                  data-aos-duration="800" 
                >
                  <img src={kuliner.src} alt={kuliner.name} className="image-wisata" key={kuliner.id}/>
                  <h6 className='mt-3 desc'>{kuliner.name}</h6>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default Kuliner;